import moment from 'moment-jalaali';

const Hydrometric = {
  inputs: [
    {
      id: 'hydrometric_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد هیدرومتریک',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'discharge',
      elementConfig: {
        type: 'text',
        placeholder: 'دبی ورودی',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/hydrometric_detail/',
  title: 'ایستگاه هیدرومتریک',
};

const Synoptic = {
  inputs: [
    {
      id: 'synoptic_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سینوپتیک',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'rainfall',
      elementConfig: {
        type: 'text',
        placeholder: 'بارش',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'min_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'دمای حداقل',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'mean_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'دمای متوسط',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'max_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'دمای حداکثر',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'sknt',
      elementConfig: {
        type: 'text',
        placeholder: 'سرعت باد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'drct',
      elementConfig: {
        type: 'text',
        placeholder: 'جهت باد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'relh',
      elementConfig: {
        type: 'text',
        placeholder: 'رطوبت نسبی',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/synoptic_detail/',
  title: 'سینوپتیک',
};

const DamHumanUsage = {
  inputs: [
    {
      id: 'dam_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'dam_item',
      elementConfig: {
        type: 'select',
        placeholder: 'dam_item',
        options: [
          { value: 'real', gainValue: 'real' },
          { value: 'program', gainValue: 'program' },
          { value: 'forecast', gainValue: 'forecast' },
        ],
      },
      indexValue: -1,
      value: '',
    },
    {
      id: 'inp_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مجموع ورودی سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'inp_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مجموع ورودی سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'output_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مجموع خروجی سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'output_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مجموع خروجی سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'farming_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف کشاورزی سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'farming_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف کشاورزی سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'drink_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف شرب سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'drink_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف شرب سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'ind_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف صنعت سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'ind_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'مصارف صنعت سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'other_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'سایر سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'other_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'سایر سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'supplied_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'supplied_cur_year',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'supplied_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'supplied_pre_year',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/dam_human_detail/',
  title: 'سد',
};

const DamHumanVolume = {
  inputs: [
    {
      id: 'dam_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'volume_cur_year',
      elementConfig: {
        type: 'text',
        placeholder: 'حجم مخزن سال جاری',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'volume_pre_year',
      elementConfig: {
        type: 'text',
        placeholder: 'حجم مخزن سال گذشته',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/dam_human_volume_detail/',
  title: 'حجم سد',
};

const WeatherStation = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'weather_item',
      elementConfig: {
        type: 'select',
        placeholder: 'نوع ایستگاه',
        options: [
          { value: 'بارش', gainValue: 'rainfall' },
          { value: 'تبخیر', gainValue: 'evaporation' },
        ],
      },
      indexValue: -1,
      value: '',
      AfterInputs: [
        [
          {
            id: 'rainfall',
            elementConfig: {
              type: 'text',
              placeholder: 'بارش',
            },
            value: '',
            validation: {
              required: true,
              isNumeric: true,
            },
            valid: false,
            touched: false,
          },
        ],
        [
          {
            id: 'evaporation',
            elementConfig: {
              type: 'text',
              placeholder: 'تبخیر',
            },
            value: '',
            validation: {
              required: true,
              isNumeric: true,
            },
            valid: false,
            touched: false,
          },
        ],
      ],
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
  ],
  url: 'upload/weather_station_detail/',
  title: 'ایستگاه هواشناسی',
};

const Aquifer = {
  inputs: [
    {
      id: 'aquifer_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد آبخوان',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'volume_change_mean',
      elementConfig: {
        type: 'text',
        placeholder: 'ميانگين تغيير حجم آبخوان (ميليون مترمكعب)',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/aquifer_detail/',
  title: 'آبخوان',
};

const Watershed = {
  inputs: [
    {
      id: 'watershed_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد آبریز',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'watershed_item',
      elementConfig: {
        type: 'select',
        placeholder: 'نوع آبریز',
        options: [
          { value: 'بارش', gainValue: 'rainfall' },
          { value: 'تبخیر', gainValue: 'evaporation' },
        ],
      },
      indexValue: -1,
      value: '',
      AfterInputs: [
        [
          {
            id: 'rainfall',
            elementConfig: {
              type: 'text',
              placeholder: 'بارش',
            },
            value: '',
            validation: {
              required: true,
              isNumeric: true,
            },
            valid: false,
            touched: false,
          },
        ],
        [
          {
            id: 'evaporation',
            elementConfig: {
              type: 'text',
              placeholder: 'تبخیر',
            },
            value: '',
            validation: {
              required: true,
              isNumeric: true,
            },
            valid: false,
            touched: false,
          },
        ],
      ],
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    // {
    //   id: 'volume_change_mean',
    //   elementConfig: {
    //     type: 'text',
    //     placeholder: 'ميانگين تغيير حجم آبخوان (ميليون مترمكعب)',
    //   },
    //   value: '',
    //   validation: {
    //     required: true,
    //     isNumeric: true,
    //   },
    //   valid: false,
    //   touched: false,
    // },
  ],
  url: 'upload/watershed_detail/',
  title: 'حوضه آبریز',
};

const LakeLevel = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'level',
      elementConfig: {
        type: 'text',
        placeholder: 'تراز',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'total_input',
      elementConfig: {
        type: 'text',
        placeholder: 'مجموع ورودی',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/lake_level/',
  title: 'تراز دریاچه',
};

const LakeEvaporation = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'evaporation',
      elementConfig: {
        type: 'text',
        placeholder: 'تبخیر',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/lake_evaporation/',
  title: 'تبخیر دریاچه',
};

const Snow = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'snow_density',
      elementConfig: {
        type: 'text',
        placeholder: 'چگالی برف',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'altitude_watersnow',
      elementConfig: {
        type: 'text',
        placeholder: 'altitude_watersnow',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'deep_snow',
      elementConfig: {
        type: 'text',
        placeholder: 'عمق برف',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/snow_detail/',
  title: 'برف',
};

const Temperature = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'date',
      elementConfig: {
        type: 'calendar',
        placeholder: 'تاریخ',
      },
      value: moment(),
      validation: {
        required: true,
      },
      valid: true,
      touched: true,
    },
    {
      id: 'minimum_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'کمینه دما',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'medium_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'دما متوسط',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
    {
      id: 'maximum_temp',
      elementConfig: {
        type: 'text',
        placeholder: 'بیشینه دما',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
    },
  ],
  url: 'upload/temperature_detail/',
  title: 'دما',
};

export const uploadTypes = {
  Hydrometric: Hydrometric,
  Synoptic: Synoptic,
  DamHumanUsage: DamHumanUsage,
  DamHumanVolume: DamHumanVolume,
  WeatherStation: WeatherStation,
  Aquifer: Aquifer,
  Watershed: Watershed,
  LakeLevel: LakeLevel,
  LakeEvaporation: LakeEvaporation,
  Snow: Snow,
  Temperature: Temperature,
};

export const uploadTypesTitles = [
  'Hydrometric',
  'Synoptic',
  'DamHumanUsage',
  'DamHumanVolume',
  'WeatherStation',
  'Aquifer',
  'Watershed',
  'LakeLevel',
  'LakeEvaporation',
  'Snow',
  'Temperature',
];
